var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.computedSuppressDebug === false && _vm.computedIsDevelopment)?_c('div',[(_vm.old)?_c('pre',{staticClass:"debug",staticStyle:{"padding":"1rem"}},[_vm._v(_vm._s(_vm.value))]):_c('vue-json-pretty',{staticClass:"debug",attrs:{"data":_vm.value,"deep":_vm.deep,"show-length":true,"show-line":false,"virtual":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }